export const defaultSpacingThemeProperties = {
  unit: 1,
};

export default function buildSpacing(spacingThemeProperties = defaultSpacingThemeProperties) {
  return {
    nospacing: 0,
    small: {
      s1: spacingThemeProperties.unit * 0.1 + 'rem',
      s2: spacingThemeProperties.unit * 0.2 + 'rem',
      s3: spacingThemeProperties.unit * 0.3 + 'rem',
      s4: spacingThemeProperties.unit * 0.4 + 'rem',
      s5: spacingThemeProperties.unit * 0.5 + 'rem',
      s6: spacingThemeProperties.unit * 0.6 + 'rem',
      s7: spacingThemeProperties.unit * 0.7 + 'rem',
      s8: spacingThemeProperties.unit * 0.8 + 'rem',
      s9: spacingThemeProperties.unit * 0.9 + 'rem',
    },
    base: spacingThemeProperties.unit + 'rem', // 10px | 1rem
    large: {
      l11: spacingThemeProperties.unit * 1.1 + 'rem',
      l12: spacingThemeProperties.unit * 1.2 + 'rem',
      l13: spacingThemeProperties.unit * 1.3 + 'rem',
      l14: spacingThemeProperties.unit * 1.4 + 'rem',
      l15: spacingThemeProperties.unit * 1.5 + 'rem',
      l16: spacingThemeProperties.unit * 1.6 + 'rem',
      l18: spacingThemeProperties.unit * 1.8 + 'rem',
      l19: spacingThemeProperties.unit * 1.9 + 'rem',
      l20: spacingThemeProperties.unit * 2 + 'rem',
      l21: spacingThemeProperties.unit * 2.1 + 'rem',
      l25: spacingThemeProperties.unit * 2.5 + 'rem',
      l26: spacingThemeProperties.unit * 2.6 + 'rem',
      l27: spacingThemeProperties.unit * 2.7 + 'rem',
      l30: spacingThemeProperties.unit * 3 + 'rem',
      l32: spacingThemeProperties.unit * 3.2 + 'rem',
      l35: spacingThemeProperties.unit * 3.5 + 'rem',
      l40: spacingThemeProperties.unit * 4 + 'rem',
      l45: spacingThemeProperties.unit * 4.5 + 'rem',
      l50: spacingThemeProperties.unit * 5 + 'rem',
      l55: spacingThemeProperties.unit * 5.5 + 'rem',
      l60: spacingThemeProperties.unit * 6 + 'rem',
      l65: spacingThemeProperties.unit * 6.5 + 'rem',
      l75: spacingThemeProperties.unit * 7.5 + 'rem'
    }
  };
}
